import { useMutation } from '@tanstack/react-query';
import type { CandidateProfileFilePostRequest } from '../types/CandidateProfile';
import type SharedSimple from '@/types/serializers/SharedSimple';

export default function usePostCandidateProfilesFile() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ candidateProfileId, file }: CandidateProfileFilePostRequest) => {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(`/agent/api/candidate_profiles/${candidateProfileId}/files`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: formData,
      });

      // 非JSONレスポンス（ALB/Pumaタイムアウト等のHTMLエラー）を安全に処理するため
      // content-typeを確認してJSONの場合のみパースする
      const contentType = response.headers.get('content-type');
      const data: SharedSimple | undefined = contentType?.includes('application/json')
        ? ((await response.json()) as SharedSimple)
        : undefined;

      if (!response.ok || !data?.success) {
        let errorMessage = 'ファイルのアップロードに失敗しました';
        if (data?.error) {
          errorMessage = data.error;
        }
        const error = new Error(errorMessage);
        (error as Error & { apiMessage?: string }).apiMessage = errorMessage;
        throw error;
      }

      return data as SharedSimple;
    },
  });
}
